<template>
	<div>
		<van-nav-bar title="群管设置" left-text="返回" left-arrow fixed placeholder @click-left="onClickLeft" v-show="this.$UserAgent.indexOf('Html5Plus')==-1?true:false" />
		<van-form @submit="onSubmit">
			
			
			<van-field v-model="number" name="number" label="警告次数:" type="number" placeholder="请输入违规警告次数" :rules="[{ required: true, message: '群成员违规警告次数，0 = 不警告直接踢出' }]"
			 maxlength="2" />
			 
			 
			 
			<van-field v-model="warn_content" name="warn_content" label="警告内容:" type="textarea" placeholder="请输入警告内容" :rules="[{ required: true, message: '群成员被警告后机器人发送的内容' }]"
			 maxlength="50" show-word-limit />
			<div style="margin-left: 0.2rem;">
				<van-tag @click="warn_content = warn_content + '[昵称]'" mark>昵称</van-tag>
			</div>
			
			<van-field name="black_checked" label="拖进小黑屋">
				<template #input>
					<van-switch v-model="black_checked" size="20" />
				</template>
			</van-field>
			<div style="margin: 16px;">
				<van-button round block type="info" native-type="submit">
					提交
				</van-button>
			</div>
		</van-form>
	</div>


</template>

<script>
	import Vue from 'vue';
	import {
		Tag
	} from 'vant';

	Vue.use(Tag);
	export default {
		data() {
			return {
				group_id: 0,
				black_checked: false,
				op: 'aset',

				number: '',
				warn_content: '',

			}
		},
		created() {
			var group_id = localStorage.getItem('select_id')
			if (!group_id) {
				this.$router.push('/member-center')
				return;
			}
			this.group_id = group_id

			this.$ApiUtil.GroupCenterSrc.get({
				a: group_id,
				v: this.op
			}).then(res => {
				if (res.status) {
					this.number = res.data.number
					this.warn_content = res.data.warn_content
					this.black_checked = res.data.black_checked
				}
			})
		},
		methods: {
			onClickLeft() {
				this.$router.back()
			},
			onSubmit(values) {
				this.$ApiUtil.GroupCenterSrc.post({
					op: this.op,
					id: this.group_id,
					values: JSON.stringify(values)
				}).then(res => {
					if (!res.status) {
						this.$toast.fail(res.message)
						return
					}
					this.$toast.success('已保存')
				})
			},
		}
	}
</script>

<style>
</style>
